// extracted by mini-css-extract-plugin
export var pageLink = "posts-module--page-link--3RO1s";
export var select_container = "posts-module--select_container--2WCSZ";
export var cathead = "posts-module--cathead--NSYta";
export var category = "posts-module--category--3qIhL";